import { Expose, Type, Transform } from "class-transformer";


export class AdvertisingItemModel {
    constructor() {
        this.id = 0;
        this.title = "";
        this.content = "";
        this.path = "";
        this.fileExtension = null;
    }

    @Expose({ name: "saleOrgMediaId" })
    id: number;

    @Expose({ name: "adName" })
    title: string;

    @Expose({ name: "adDetail" })
    content: string;

    @Expose({ name: "path" })
    path: string

    @Expose({ name: "fileExtension" })
    fileExtension: string | null
}
